import EvalTrainingDialog from './src/main';

/* istanbul ignore next */
EvalTrainingDialog.install = function(Vue) {
  Vue.component(EvalTrainingDialog.name, EvalTrainingDialog);
};

export default EvalTrainingDialog;
